// import { LOCAL_STORAGE_KEYS } from 'src/constants/StorageKeys';

export const LOCAL_STORAGE_KEYS = {
  LAST_CHECKED_AT: btoa('LAST_CHECKED_AT')
};

export const BUILD_CHECK_POLL_TIMEOUT = 3600e3;

export const refresh = (e?: React.SyntheticEvent) => {
  location.reload();
  if (e) {
    e.preventDefault();
    return false;
  }
};

const localBuildTime = window?.config?.BUILD_TIME || Date.now();
let lastCheckedAt = Number(localStorage.getItem(LOCAL_STORAGE_KEYS.LAST_CHECKED_AT));
let lastConfirmationTriggerredTime = 0;

export type iCheckVersionResponse = {
  buildTime: number;
};

const markChecked = () => {
  lastCheckedAt = Date.now();
  localStorage.setItem(LOCAL_STORAGE_KEYS.LAST_CHECKED_AT, lastCheckedAt.toString());
};

export const checkBuildTime = (
  response: iCheckVersionResponse,
  nudgeCallback: (show: boolean) => void
): void => {
  const NOW = Date.now();
  const responseBuildTime = response.buildTime;
  const lastCheckedDate = new Date(lastCheckedAt).getDate();
  const today = new Date(NOW).getDate();
  const lastCheckedDiff = NOW - lastConfirmationTriggerredTime;

  markChecked();

  if (lastCheckedDate !== today) {
    // if the day has changed then force refresh
    // removing this line will add later
    // alert('Page will be updated to fetch the latest update in the app');
    refresh();
    return;
  }

  if (responseBuildTime == localBuildTime) {
    return;
  }

  // true => new build has come up and we need to refresh.
  if (responseBuildTime > localBuildTime) {
    // if (lastCheckedDiff >= 1e4) {
    if (typeof nudgeCallback === 'function') {
      return nudgeCallback(true);
    }
    // const userConfirmation = confirm('There is an app update and page will be refreshed on your confirmation');
    // lastConfirmationTriggerredTime = NOW;

    // if (userConfirmation) {
    //   return refresh();
    // }
    // }
  }
  nudgeCallback(false);
};

export const handleBuildNudgeInNewPortal =
  (dispatch: any, setShowStickyNote: any) => (show: boolean) => {
    dispatch?.(setShowStickyNote(show));
  };

export const handleBuildNudgeInOldPortal = (dispatch: any) => {
  // dispatch(setToast({ message: 'An update of the app is available, please refresh the page', severity: ToastSeverity.STICKY, sticky: true }));
};
